import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { errorReporting } from '@/services/error-reporting.service'

// ---------------------------------------------------------------------------
// Global error handlers — catch unhandled errors and promise rejections
// ---------------------------------------------------------------------------
window.addEventListener('error', (event) => {
  errorReporting.captureException(event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  errorReporting.captureException(event.reason);
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
